<template>
    <b-modal
        v-model="modalShow"
        size="lg"
        title="英語化問診票作成： 入力内容を確認"
        hide-footer
        @hidden="close">
        <div
            v-if="user === null || transQuestions === null"
            class="d-flex justify-content-center align-items-center pt-5 pb-5">
            <b-spinner variant="yokumiru-user"></b-spinner>
        </div>
        <div v-else class="mb-3">
            <div class="mb-3">入力した内容を確認し、間違いがなければ「翻訳する」ボタンを押してください。</div>
            <div class="row">
                <div class="col">
                    <div class="form-group">
                        <label>セイ</label>
                        <input
                            :value="user.last_name_kana"
                            type="text"
                            class="form-control"
                            disabled>
                    </div>
                </div>
                <div class="col">
                    <div class="form-group">
                        <label>メイ</label>
                        <input
                            :value="user.first_name_kana"
                            type="text"
                            class="form-control"
                            disabled>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div class="form-group">
                        <label>生年月日</label>
                        <input
                            :value="helper.birthdayForHuman(user.birthday)"
                            type="text"
                            class="form-control"
                            disabled>
                    </div>
                </div>
                <div class="col">
                    <div class="form-group">
                        <label>性別</label>
                        <input
                            :value="user.sex ? '女性' : '男性'"
                            type="text"
                            class="form-control"
                            disabled>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div class="form-group">
                        <label>身長</label>
                        <div class="input-group">
                            <input
                                :value="user.height || '-'"
                                type="text"
                                class="form-control"
                                disabled>
                            <div class="input-group-append">
                                <span class="input-group-text">cm</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="form-group">
                        <label>体重</label>
                        <div class="input-group">
                            <input
                                :value="user.weight || '-'"
                                type="text"
                                class="form-control"
                                disabled>
                            <div class="input-group-append">
                                <span class="input-group-text">kg</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div class="form-group">
                        <label>血液型</label>
                        <div class="input-group">
                            <input
                                :value="user.blood || '-'"
                                type="text"
                                class="form-control"
                                disabled>
                            <div class="input-group-append">
                                <span class="input-group-text">型</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="form-group">
                        <label>体温</label>
                        <div class="input-group">
                            <input
                                v-model="bodyTemperature"
                                type="text"
                                class="form-control"
                                disabled>
                            <div class="input-group-append">
                                <span class="input-group-text">℃</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-for="( q, idx ) in transQuestions">
                <label>{{ q.title }}</label>
                <div class="mb-3">
                    <template v-if="Number( q.interview_question_type_id ) === questionTypes.multiInput">
                            <textarea
                                v-model="q.content"
                                class="form-control"
                                :id="`q-${q.id}`"
                                disabled>
                            </textarea>
                    </template>
                    <template v-else>
                        <input
                            v-model="q.content"
                            type="text"
                            class="form-control"
                            :id="`q-${q.id}`"
                            disabled>
                    </template>
                </div>
            </div>

            <div class="mt-4 pt-2 mb-4">
                <p class="is-required-ja-self text-center font-weight-bold u-palt mb-2">英語化問診票サービスはAIを用いて翻訳を行っており、医師や専門家による作成ではありません。</p>
                <div class="d-flex justify-content-center">
                    <div class="custom-control custom-checkbox">
                        <input
                            v-model="agreement"
                            value="1"
                            type="checkbox"
                            id="agreement"
                            class="custom-control-input">
                        <label
                            for="agreement"
                            class="custom-control-label"
                            style="cursor: pointer;">
                            確認しました
                        </label>
                    </div>
                </div>
            </div>

            <b-button
                class="nextButton"
                :disabled="inProgress || !agreement"
                @click="handleOk">
                {{ inProgress ? '処理中です…' : '翻訳する' }}
            </b-button>
        </div>
    </b-modal>
</template>

<script>
    import YokumiruHelper from '../../../YokumiruHelper'
    import constants from '../../../constants'
    import {mapMutations} from "vuex";

    export default {
        data: function () {
            return {
                helper: YokumiruHelper,
                inProgress: false,
                agreement: false,
                modalShow: false,
                user: null,
                bodyTemperature: null,
                medicalCourse: null,
                transQuestions: null,
                questionTypes: constants.interview_question_types,
                errors: {},
            }
        },

        created: function() {
            bus.$on('open-modal-user-interview-trans-questions-confirm', this.open)
            bus.$on('user-interview-trans-completed', this.close)
        },

        beforeDestroy: function() {
            bus.$off('open-modal-user-interview-trans-questions-confirm')
            bus.$off('user-interview-trans-completed')
        },

        methods: {
            ...mapMutations({
                setTransProfile: 'userInterviewTransAnswers/setTransProfile',
                setTransAnswers: 'userInterviewTransAnswers/setTransAnswers',
            }),

            /**
             * モーダル表示
             */
            open: function () {
                this.modalShow = true
                this.user = this.$store.state.userInterviewTransAnswers.user
                this.bodyTemperature = this.$store.state.userInterviewTransAnswers.bodyTemperature
                this.medicalCourse = this.$store.state.userInterviewTransAnswers.medicalCourse
                this.transQuestions = this.$store.state.userInterviewTransAnswers.transQuestions
            },

            /**
             * モーダル非表示
             */
            close: function() {
                this.modalShow = false
            },

            /**
             * 「翻訳する」ボタン押下時
             * @param {object} e
             */
            handleOk: async function(e) {
                e.preventDefault()

                if (this.inProgress) return
                this.inProgress = true

                const profile = this.$store.state.userInterviewTransAnswers.transProfile
                const params = {
                    trans_questions: this.transQuestions,
                    body_temperature: this.bodyTemperature,
                    trans_profile_id: profile ? profile.id : null,
                }
                const endpoint = constants.user.medical_courses.endpoint.base

                await axios.post(`${endpoint}/${this.medicalCourse.id}/interview_trans_answers`, params)
                    .then(({data}) => {
                        this.errors = {}
                        this.setTransProfile(data.data.trans_profile)
                        this.setTransAnswers(data.data.trans_answers)
                        bus.$emit('open-modal-user-interview-trans-answers')
                    })
                    .catch( ({response}) => {
                        this.errors = response.data.errors
                        bus.$emit('alert-danger')
                    })

                this.inProgress = false
            },
        },
    }
</script>

<style lang="scss" scoped>
.prevButton,
.nextButton {
    display: block;
    width: 210px;
    height: 42px;
    line-height: 42px;
    padding: 0;
    margin: 0 auto;
    color: #fff;
    font-weight: bold;
    text-align: center;
    background-color: #CF798A;
    border: none;
    border-radius: 8px;
    cursor: pointer;
}

.prevButton {
    color: #333;
    background-color: #D9D9D9;
}
</style>
